import React, { useState, useEffect } from 'react';

const steps = [
  {
    icon: '🛍️',
    title: 'Pilih Produk',
    desc: 'Lihat daftar produk yang tersedia. Klik tombol "+ Keranjang" pada produk yang ingin kamu beli.',
    color: '#00dcb4',
  },
  {
    icon: '🛒',
    title: 'Cek Keranjang',
    desc: 'Klik ikon Keranjang di navbar. Kamu bisa ubah jumlah atau hapus produk sebelum checkout.',
    color: '#3b82f6',
  },
  {
    icon: '📝',
    title: 'Isi Data Diri',
    desc: 'Masukkan nama lengkap dan nomor HP/WhatsApp kamu. Tidak perlu alamat — semua serba digital!',
    color: '#a78bfa',
  },
  {
    icon: '⚡',
    title: 'Scan QRIS',
    desc: 'QR Code akan muncul. Buka e-wallet atau m-banking kamu, pilih Scan QR, lalu arahkan ke kode tersebut.',
    color: '#f59e0b',
  },
  {
    icon: '✅',
    title: 'Pembayaran Selesai',
    desc: 'Setelah bayar, status otomatis terupdate. Simpan Order ID untuk cek riwayat pesananmu kapan saja.',
    color: '#22d3a0',
  },
];

export default function TutorialPopup() {
  const [visible, setVisible] = useState(false);
  const [current, setCurrent] = useState(0);
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    // Tampilkan hanya jika belum pernah lihat
    const seen = localStorage.getItem('tutorial_seen');
    if (!seen) {
      setTimeout(() => setVisible(true), 600);
    }
  }, []);

  const close = () => {
    setClosing(true);
    setTimeout(() => {
      setVisible(false);
      setClosing(false);
      localStorage.setItem('tutorial_seen', '1');
    }, 300);
  };

  const next = () => {
    if (current < steps.length - 1) setCurrent(c => c + 1);
    else close();
  };

  const prev = () => { if (current > 0) setCurrent(c => c - 1); };

  if (!visible) return null;

  const step = steps[current];

  return (
    <>
      {/* Overlay */}
      <div
        onClick={close}
        style={{
          position: 'fixed', inset: 0,
          background: 'rgba(4,8,15,0.85)',
          backdropFilter: 'blur(6px)',
          zIndex: 999,
          animation: closing ? 'fadeOut 0.3s ease forwards' : 'fadeIn 0.3s ease forwards',
        }}
      />

      {/* Modal */}
      <div style={{
        position: 'fixed',
        top: '50%', left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 1000,
        width: '90%',
        maxWidth: 420,
        background: 'var(--card)',
        border: '1px solid var(--border2)',
        borderRadius: 20,
        overflow: 'hidden',
        boxShadow: '0 32px 80px rgba(0,0,0,0.6), 0 0 40px rgba(0,220,180,0.1)',
        animation: closing ? 'popOut 0.3s cubic-bezier(0.22,1,0.36,1) forwards' : 'popIn 0.4s cubic-bezier(0.22,1,0.36,1) forwards',
      }}>

        {/* Header */}
        <div style={{
          padding: '18px 20px 14px',
          borderBottom: '1px solid var(--border)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          background: 'rgba(0,0,0,0.2)',
        }}>
          <div>
            <div style={{ fontFamily: 'var(--mono)', fontSize: '0.65rem', color: 'var(--primary)', textTransform: 'uppercase', letterSpacing: 2, marginBottom: 3 }}>
              // Panduan Belanja
            </div>
            <div style={{ fontWeight: 800, fontSize: '1rem', color: 'var(--text)' }}>
              Cara Pesan & Bayar
            </div>
          </div>
          <button
            onClick={close}
            style={{
              background: 'var(--bg3)', border: '1px solid var(--border)',
              borderRadius: 8, width: 32, height: 32,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              cursor: 'pointer', color: 'var(--text2)', fontSize: '1rem',
              transition: 'all 0.2s',
            }}
            onMouseEnter={e => e.target.style.borderColor = 'var(--danger)'}
            onMouseLeave={e => e.target.style.borderColor = 'var(--border)'}
          >✕</button>
        </div>

        {/* Step dots */}
        <div style={{ display: 'flex', justifyContent: 'center', gap: 6, padding: '14px 20px 0' }}>
          {steps.map((_, i) => (
            <div
              key={i}
              onClick={() => setCurrent(i)}
              style={{
                width: i === current ? 24 : 8,
                height: 8,
                borderRadius: 4,
                background: i === current ? step.color : 'var(--border2)',
                cursor: 'pointer',
                transition: 'all 0.3s cubic-bezier(0.22,1,0.36,1)',
              }}
            />
          ))}
        </div>

        {/* Step content */}
        <div style={{ padding: '20px 24px 24px', minHeight: 220 }}>
          {/* Icon */}
          <div style={{
            width: 72, height: 72,
            borderRadius: 18,
            background: `rgba(${hexToRgb(step.color)}, 0.12)`,
            border: `1.5px solid rgba(${hexToRgb(step.color)}, 0.3)`,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: '2.2rem',
            marginBottom: 18,
            boxShadow: `0 0 24px rgba(${hexToRgb(step.color)}, 0.15)`,
            transition: 'all 0.3s',
          }}>
            {step.icon}
          </div>

          {/* Step number */}
          <div style={{
            fontFamily: 'var(--mono)',
            fontSize: '0.68rem',
            color: step.color,
            textTransform: 'uppercase',
            letterSpacing: 2,
            marginBottom: 6,
          }}>
            Langkah {current + 1} dari {steps.length}
          </div>

          {/* Title */}
          <div style={{
            fontSize: '1.25rem',
            fontWeight: 800,
            color: 'var(--text)',
            marginBottom: 10,
            letterSpacing: '-0.3px',
          }}>
            {step.title}
          </div>

          {/* Desc */}
          <div style={{
            fontSize: '0.9rem',
            color: 'var(--text2)',
            lineHeight: 1.65,
          }}>
            {step.desc}
          </div>
        </div>

        {/* Footer navigation */}
        <div style={{
          padding: '0 24px 22px',
          display: 'flex',
          gap: 10,
        }}>
          {current > 0 && (
            <button
              onClick={prev}
              style={{
                flex: 1,
                padding: '11px',
                background: 'var(--bg3)',
                border: '1px solid var(--border)',
                borderRadius: 10,
                color: 'var(--text2)',
                fontWeight: 700,
                fontSize: '0.88rem',
                cursor: 'pointer',
                fontFamily: 'var(--font)',
                transition: 'all 0.2s',
              }}
            >
              ← Kembali
            </button>
          )}
          <button
            onClick={next}
            style={{
              flex: 2,
              padding: '11px',
              background: step.color,
              border: 'none',
              borderRadius: 10,
              color: '#04080f',
              fontWeight: 800,
              fontSize: '0.9rem',
              cursor: 'pointer',
              fontFamily: 'var(--font)',
              boxShadow: `0 0 20px rgba(${hexToRgb(step.color)}, 0.35)`,
              transition: 'all 0.2s',
            }}
          >
            {current < steps.length - 1 ? `Selanjutnya →` : '✅ Mengerti, Mulai Belanja!'}
          </button>
        </div>

      </div>

      <style>{`
        @keyframes fadeIn  { from { opacity: 0 } to { opacity: 1 } }
        @keyframes fadeOut { from { opacity: 1 } to { opacity: 0 } }
        @keyframes popIn   { from { opacity: 0; transform: translate(-50%,-50%) scale(0.85) } to { opacity: 1; transform: translate(-50%,-50%) scale(1) } }
        @keyframes popOut  { from { opacity: 1; transform: translate(-50%,-50%) scale(1) } to { opacity: 0; transform: translate(-50%,-50%) scale(0.9) } }
      `}</style>
    </>
  );
}

function hexToRgb(hex) {
  const r = parseInt(hex.slice(1,3),16);
  const g = parseInt(hex.slice(3,5),16);
  const b = parseInt(hex.slice(5,7),16);
  return `${r},${g},${b}`;
}
